import { FC, memo } from "react";
import styled from "styled-components";
import { IWorkItem } from "../../../models/BlenderAgentStateModel";
import { dxpLayout } from "../../../style/theme";
import { getEnvSettings } from "../../../app/hostBasedSettings";
import { selectAuth } from "../../../redux/slices/authSlice";
import { useSelector } from 'react-redux';
import { useAppSelector} from "../../../redux/hooks";
import CustomerLookupFragment from '@buzzeasy/contact-lookup-fragment';

interface IProps {
    workItem: IWorkItem;
}

const RootContainer = styled.div`
  width: 100%;
  height: calc(100% - ${dxpLayout.workItemHeaderHeight});
`;

const LookupFragment: FC<IProps> = memo(({ workItem }) => {
  const envSettings = getEnvSettings();
  const apiBaseUrl = envSettings.apiBaseURL;
  const { token } = useSelector(selectAuth);
  const hideInfo = useAppSelector(
    (state) => state.blenderState.agentClientState.agentProperties.displaySettings.hideSensitiveAgentInformation
  );
    
  return (
    <RootContainer>
    <CustomerLookupFragment
       apiBaseUrl={apiBaseUrl}
       token={token}
       workItemId={workItem.workItemId}
       featureFlags={{hideSensitiveAgentInformation:hideInfo}}
    />
    </RootContainer>
  );
});

export default LookupFragment;




  